import React, { useRef, useState } from "react";
function useNoEmailChange() {
  const noEmailRef = useRef(0);
  const [noEmailVisible, setNoEmailVisible] = useState(false);
  const noEmailChange = () => {
    if (noEmailVisible) return;
    if (noEmailRef.current) {
      setNoEmailVisible(true);
    }
    noEmailRef.current = 1;
  };
  return { noEmailVisible, noEmailChange };
}

export default useNoEmailChange;
